import React from 'react'
import { Box, Grid, Typography } from '@mui/material';

const TechCustView = ({ tech }) => {
    return (
        <Box>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >고객명</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Typography variant="body2" component="div" >{tech?.custNm}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >계약상태</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body2" component="div" >{tech?.signStatus}</Typography>
                </Grid>
            </Grid>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >사업장 소재지(주소)</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography variant="body2" component="div" >{tech?.custAddr}</Typography>
                </Grid>
            </Grid>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >담당자명</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2" component="div" >{tech?.custEmpNm}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >연락처</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2" component="div" >{tech?.custTel}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div" >이메일</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2" component="div" >{tech?.custEml}</Typography>
                </Grid>
            </Grid>
        </Box>

    )
}

export default TechCustView